import {Component, inject} from '@angular/core';
import {Router} from '@angular/router';
import {OidcSecurityService} from 'angular-auth-oidc-client';

@Component({
  selector: 'app-auth-error',
  standalone: false,
  templateUrl: './auth-error.component.html',
  styleUrl: './auth-error.component.less'
})
export class AuthErrorComponent {
  private readonly router = inject(Router);
  private readonly oidcSecurityService = inject(OidcSecurityService);

  // Vuelve a la ruta que se pidio al entrar: el authGuard se ejecuta de nuevo y reintenta cargar el usuario.
  retry(): void {
    const currentPathname = localStorage.getItem('currentPathname') || '/home';
    this.router.navigateByUrl(this.router.parseUrl(currentPathname));
  }

  logout(): void {
    this.oidcSecurityService.logoff().subscribe();
  }
}
